var productCardMarkup = `
  <div class="swym-wishlist-grid collection-grid">
   {{#products}} 
     <div class="product-item swym-wishlist-item swym-is-anchorc col_slide">
        <div class="snippet-product-grid" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">
           <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
             <span class="swym-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g filter="url(#filter0_b_1809_13636)"><mask id="mask0_1809_13636" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="1" width="16" height="14"><path d="M12.8749 2.37154C10.0435 0.968644 8 3.99064 8 3.99064C8 3.99064 6.13642 1.15692 3.27083 2.37154C1.03243 3.32033 0.206979 6.18412 1.90411 7.99885C4.02499 10.2667 8 14.0001 8 14.0001C8 14.0001 12.3666 9.7652 14.0561 7.99885C15.7457 6.23249 15.0549 3.45173 12.8749 2.37154Z" fill="#D9D9D9" stroke="#7B7474" stroke-linejoin="round"/></mask><g mask="url(#mask0_1809_13636)"><rect y="1" width="16" height="14" fill="#D97C95"/></g></g><defs><filter id="filter0_b_1809_13636" x="-60" y="-60" width="136" height="136" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="30"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1809_13636"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1809_13636" result="shape"/></filter></defs></svg></span>
           </button>
           <span class="swym-tooltip swym-inject swym-tooltip-clickable"><span class="swym-tooltip-text">Add to wishlist</span></span></button>
           <div class="grid-top">
              <div class="grid-imagebox">
                 <a href="{{du}}" class="product-link">
                    <div class="grid-badge"><span>&nbsp;</span></div>
                    <div class="product-images">
                      <img alt="" class="swym-wishlist-image" src="{{iu}}">
                      <img alt="" class="second-image" src="">
                    </div>
                 </a>
              </div>
              <div class="grid-meta">
                 <div class="grid-meta-inr" bss-b2b-product-id="8736644104356" bss-b2b-product-parent-price="true" style="visibility: visible;">
                    <p class="grid-title"><a href="{{du}}">{{dt}}</a></p>
                    <p class="grid-price">
                      <span class="swym-product-final-price original-price" data-wpd-product-handle="" data-wpd-variant-id="{{epi}}" 
                      data-wpd-variant-price="" data-wpd-variant-compare-at-price="" data-wpd-product-id="{{empi}}">{{cu}}{{pr}}</span>
                      <span class="compare-price d-none">{{cu}}<span>&nbsp;</span></span>
                    </p>
                 </div>
              </div>
           </div>
           <div class="grid-btm">
              <div class="size_variant">
                 <div class="grid-variant-outer">
                    <div class="grid-error"></div>
                    <span>Choose a size:</span>
                    <div class="grid-size-wrapper">&nbsp;</div>
                 </div>
              </div>
              <div class="grid-variant-btns">
                 <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="button button-full site-add-btn swym-add-to-cart-btn swym-is-button">
                   <span class="adding-cart">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><g clip-path="url(#clip0_1_36487)" filter="url(#filter0_b_1_36487)"><path d="M12.1875 6.09375V6.5C12.1875 9.64112 9.64112 12.1875 6.5 12.1875V12.1875C3.35888 12.1875 0.8125 9.64112 0.8125 6.5V6.5C0.8125 3.35888 3.35888 0.8125 6.5 0.8125V0.8125" stroke="currentColor" stroke-width="0.8125" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><filter id="filter0_b_1_36487" x="-60" y="-60" width="133" height="133" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feGaussianBlur in="BackgroundImageFix" stdDeviation="30"></feGaussianBlur><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_36487"></feComposite><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_36487" result="shape"></feBlend></filter><clipPath id="clip0_1_36487"><rect width="13" height="13" fill="white"></rect></clipPath></defs></svg>
                      <span>Adding to cart</span>
                   </span>
                   <span class="added-cart">
                     <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><g filter="url(#filter0_b_1_36281)"><path d="M0.8125 8.125L4.0625 10.9688L12.1875 1.625" stroke="currentColor" stroke-width="0.8125" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><filter id="filter0_b_1_36281" x="-60" y="-60" width="133" height="133" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feGaussianBlur in="BackgroundImageFix" stdDeviation="30"></feGaussianBlur><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_36281"></feComposite><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_36281" result="shape"></feBlend></filter></defs></svg>
                     <span>Added to cart</span>
                    </span>
                    <span class="p-add-cart-btn">Add to cart</span>
                 </button>
              </div>
           </div>
        </div>
     </div>
   {{/products}}
</div>`;
var variantModalMarkUp = `
  <div class="wishlist-sizedrawer" id="modal">
    <div class="modal-guts">
      {{#product.options}}
        <div class="select-variant-{{name}} grid-size-variants" id="user-options-{{name}}">
          {{#values}}
            <div class="sywm-radio">
              <input type="radio" name="{{name}}_{{ product.id  }}" data-value="{{.}}" id="user-option{{.}}_{{ product.id  }}">
              <label for="user-option{{.}}_{{product.id}}">{{.}}<span class="favourite-dots"></span></label>
            </div>
          {{/values}}
        </div>
      {{/product.options}}
    </div>
  </div>`;
function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.currentTarget.getAttribute("data-product-url");
  e.currentTarget.classList.add("addingCart");
  let get_swat = setInterval(function () {
    if (window._swat != null) {
      clearInterval(get_swat);
      window._swat.replayAddToCart(
        {
          empi: productId,
          du: du,
        },
        variantId,
        function (c) {
          e.target.setAttribute("data-state-cart", "swym-added");
          load_cart();
          setTimeout(function (e) {
            document.querySelector("body").classList.add("open-drawer");
          }, 500);
          setTimeout(() => {
            e.target
              .closest(".swym-add-to-cart-btn")
              .classList.remove("addingCart");
            e.target
              .closest(".swym-add-to-cart-btn")
              .classList.add("addedCart");
            setTimeout(() => {
              e.target
                .closest(".swym-add-to-cart-btn")
                .classList.remove("addedCart");
            }, 2000);
          }, 1300);
          console.log("Successfully added product to cart.", c);
        },
        function (e) {
          console.log(e);
        }
      );
    }
  }, 1000);
}
function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}
function swymRenderWishlist(swat) {
  swat.fetch(function (products) {
    document.querySelector(".wishlist-count").textContent =
      "(" + products.length + ")";
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map(function (p, n) {
      completeProductJson = {};
      var productId = p.empi;
      var variantId = p.epi;
      var variantTitle = p.vi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };
      variantButtonAttributes = {};
      variantButtonAttributes = params;
      window._swat.getProductDetails(params, function (productJson) {
        // console.log("productJson", productJson);
        completeProductJson = productJson;
        productJson.du = du;
        var variantMarkUpTemplate = SwymUtils.renderTemplateString(
          variantModalMarkUp,
          {
            product: productJson,
          }
        );
        document.querySelectorAll('.snippet-product-grid[data-product-id="' +productId +'"] .grid-size-wrapper').forEach((variantAdd) => {
          variantAdd.innerHTML = variantMarkUpTemplate;
        });
        if (n == products.length - 1) {
          attachModalEventListeners();
        }
        // document.querySelector(
        //   '.snippet-product-grid[data-product-id="' +
        //     productJson.id +
        //     '"] .original-price'
        // ).textContent = document
        //   .querySelector(".snippet-product-grid .original-price")
        //   .textContent.split(".")[0];
        let price = productJson.price;
        let handle = productJson.handle;
        let compare_at_price = productJson.compare_at_price;
        document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',price);
        document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-product-handle',handle);
        if (compare_at_price != null) {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.remove("d-none");
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price span').textContent = compare_at_price / 100;
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-compare-at-price',compare_at_price);
          if (compare_at_price > price) {
            let saving = ((compare_at_price - price) * 100) / compare_at_price;
            function customRound(value) {
              let remainder = value % 5;
              if (remainder <= 2) {
                return value - remainder;
              } else {
                return value + (5 - remainder);
              }
            }
            let roundedSaving = customRound(saving);
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-badge span').textContent = roundedSaving + "% off";
          }
        } else {
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').style.color = "#464545";
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.add("d-none");
        }
        // if(productJson.images[0]){
        //   document.querySelector('.snippet-product-grid[data-product-id="'+productJson.id+'"] .swym-wishlist-image').setAttribute('src',productJson.images[0]);
        // }
        if (productJson.images[1]) {
          document
            .querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] .second-image'
            )
            .setAttribute("src", productJson.images[1]);
        } else {
          document.querySelector(
            '.snippet-product-grid[data-product-id="' +
              productJson.id +
              '"] .swym-wishlist-image'
          ).style.opacity = "1";
          document
            .querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] .second-image'
            )
            .classList.add("d-none");
        }
        if (productJson.available == false) {
          document
            .querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] #swym-custom-add-toCartBtn'
            )
            .classList.add("grid-soldOut");
          document.querySelector(
            '.snippet-product-grid[data-product-id="' +
              productJson.id +
              '"] .p-add-cart-btn'
          ).textContent = "Sold out";
          document.querySelector(
            '.snippet-product-grid[data-product-id="' +
              productJson.id +
              '"] .grid-badge span'
          ).textContent = "Sold out";
        }
        let tag = productJson.tags;
        tag.forEach(function (i, value) {
          if (i.includes("PreOrder")) {
            document.querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] .grid-badge span'
            ).textContent = "Pre-order";
            document
              .querySelector(
                '.snippet-product-grid[data-product-id="' +
                  productJson.id +
                  '"] .grid-badge span'
              )
              .classList.add("preorder-badge");
            document.querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] .p-add-cart-btn'
            ).textContent = "Pre-order";
            document
              .querySelector(
                '.snippet-product-grid[data-product-id="' +
                  productJson.id +
                  '"] .swym-add-to-cart-btn'
              )
              .classList.add("button-pink");
          } else if (i.includes("badge-coming-soon")) {
            document.querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] .grid-badge span'
            ).textContent = "Coming Soon";
            document.querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] .p-add-cart-btn'
            ).textContent = "Coming Soon";
            document
              .querySelector(
                '.snippet-product-grid[data-product-id="' +
                  productJson.id +
                  '"] .swym-add-to-cart-btn'
              )
              .classList.add("button-pink");
          }
        });
        var jsonvariantid = productJson.variants;
        jsonvariantid.forEach(function (i, value) {
          const element = document.querySelector('.snippet-product-grid[data-variant-id="' +variantId +'"] .sywm-radio [data-value="' +i.option1 +'"]');
          if (i.available == false) {
            const nextLabel = element.nextElementSibling;
            if (nextLabel) nextLabel.classList.add("soldout_variant");
          }
          var allvarName = i.title;
          if (i.option1 == variantTitle) {
            element.checked = true;
            const nextLabel = element.nextElementSibling;
            if (nextLabel) nextLabel.classList.add("active");
          }
        });
      });
      countWishlist();
      console.log(p.pr, "before format");
      p = SwymUtils.formatProductPrice(p);
      console.log(p.pr, "after format");
      p.pr = p.pr.split('.')[0];
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (p.vi) {
        p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
        if (p.vi.includes("/")) {
          p.vi = p.vi.split("/")[0];
        } else if (p.vi.includes(" ")) {
          p.vi = p.vi.split(" ")[0];
        }
      }
      return p;
    });
    console.log(formattedWishlistedProducts, "testing");
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      document.querySelectorAll(".swym-wishlist-image").forEach((firstImg) => {
        let srcVal = firstImg.getAttribute("src");
        if (srcVal.includes("_620x620")) {
          srcVal = srcVal.replaceAll("_620x620", "");
        } else if (srcVal.includes("620")) {
          srcVal = srcVal.replaceAll("620", "");
        }
        firstImg.setAttribute("src", srcVal);
      });
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}
function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
}
function countWishlist() {
  window._swat.fetch(function (r) {
    document.querySelector(".wishlist-count").textContent =
      "(" + r.length + ")";
  });
}
function attachModalEventListeners() {
  document
    .querySelectorAll(".product-item .sywm-radio>input")
    .forEach((allInput) => {
      allInput.addEventListener("click", function (e) {
        e.preventDefault();
        var paranode1 = e.target.closest(".snippet-product-grid");
        var productId = paranode1.getAttribute("data-product-id");
        var variantId = paranode1.getAttribute("data-variant-id");
        var du = paranode1.getAttribute("data-url");
        console.log(
          "productId-->",
          productId,
          "variantId",
          variantId,
          "du",
          du
        );
        var params = {
          du: du,
          empi: parseInt(productId),
          epi: parseInt(variantId),
        };
        window._swat.getProductDetails(params, function (productJson1) {
          completeProductJson1 = productJson1;
          console.log("completeProductJson1-->", completeProductJson1);
          var userSelectionData = getSelectTagValues(allInput);
          var variant = findVariant(userSelectionData, completeProductJson1);
          var variantButtonAttributes = params;
          removeProductFromWishlist(
            variantButtonAttributes,
            function (removedProduct) {
              var newProductVariantAttributes = {
                empi: removedProduct.empi,
                epi: variant.id,
                du: removedProduct.du,
              };
              addProductToWishlist(newProductVariantAttributes);
            }
          );
        });
        allInput.closest(".sywm-radio").classList.add("active");
      });
    });
}
function getSelectTagValues(selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var optionValue = selector.getAttribute("data-value");
    console.log(optionValue, "selector*************************", selector);
    if (optionValue != undefined) {
      var key = "option" + (0 + 1);
      var selectedValueObj = _defineProperty({}, key, optionValue.toString());
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    }
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function _defineProperty(obj, key, value) {
  console.log("value------------>", value);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption, completeProductJson1) {
  var keys = Object.keys(userSelectedOption).filter(function (key) {
    return (
      userSelectedOption[key] !== null && userSelectedOption[key] !== undefined
    );
  });
  var match = completeProductJson1.variants.find(function (variant) {
    return keys.every(function (key, value) {
      return (
        variant[key] === userSelectedOption[key] &&
        variant[value] === userSelectedOption[value]
      );
    });
  });
  return match;
}
function removeProductFromWishlist(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function (r) {
    callback(r);
  });
}
function addProductToWishlist(new_product_variant) {
  window._swat.addToWishList(new_product_variant, function (r) {
    renderWishlistUI();
  });
}
function renderWishlistUI() {
  _swat.fetch(function (products) {
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for (let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails(
        {
          du: WishlistedProducts[i].du,
          epi: WishlistedProducts[i].epi,
          empi: WishlistedProducts[i].empi,
        },
        function (fullProductDetails) {
          for (let j = 0; j < fullProductDetails.variants.length; j++) {
            if (
              fullProductDetails.variants[j].id == WishlistedProducts[i].epi
            ) {
              WishlistedProducts[i].available =
                fullProductDetails.variants[j].available;
            }
          }
        }
      );
    }
    setTimeout(function (e) {
      var h3height = 0;
    }, 2000);
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    currentUserWishlist = products;
    var completeProductJson = {};
    var formattedWishlistedProducts = WishlistedProducts.map(function (p, n) {
      var productId = p.empi;
      var variantId = p.epi;
      var variantTitle = p.vi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };
      variantButtonAttributes = {};
      variantButtonAttributes = params;
      window._swat.getProductDetails(params, function (productJson) {
        completeProductJson = productJson;
        productJson.du = du;
        var variantMarkUpTemplate = SwymUtils.renderTemplateString(
          variantModalMarkUp,
          {
            product: productJson,
          }
        );
        document
          .querySelectorAll(
            '.snippet-product-grid[data-product-id="' +
              productId +
              '"] .grid-size-wrapper'
          )
          .forEach((variantAdd) => {
            variantAdd.innerHTML = variantMarkUpTemplate;
          });
        if (n == products.length - 1) {
          attachModalEventListeners();
        }
        if (productJson.available == false) {
          document
            .querySelector(
              '.snippet-product-grid[data-product-id="' +
                productJson.id +
                '"] #swym-custom-add-toCartBtn'
            )
            .classList.add("grid-soldOut");
          document.querySelector(
            '.snippet-product-grid[data-product-id="' +
              productJson.id +
              '"] .p-add-cart-btn'
          ).textContent = "Sold out";
          document.querySelector(
            '.snippet-product-grid[data-product-id="' +
              productJson.id +
              '"] .grid-badge span'
          ).textContent = "Sold out";
        }
        var jsonvariantid = productJson.variants;
        jsonvariantid.forEach(function (i, value) {
          const element = document.querySelector(
            '.snippet-product-grid[data-variant-id="' +
              variantId +
              '"] .sywm-radio [data-value="' +
              i.option1 +
              '"]'
          );
          if (i.available == false) {
            const nextLabel = element.nextElementSibling;
            if (nextLabel) nextLabel.classList.add("soldout_variant");
          }
          var allvarName = i.title;
          if (i.option1 == variantTitle) {
            element.checked = true;
            const nextLabel = element.nextElementSibling;
            if (nextLabel) nextLabel.classList.add("active");
          }
        });
      });
      countWishlist();
      p = SwymUtils.formatProductPrice(p);
      p.pr = p.pr.split('.')[0];
      p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      if (p.vi) {
        if (p.vi.includes("/")) {
          p.vi = p.vi.split("/")[0];
        } else if (p.vi.includes(" ")) {
          p.vi = p.vi.split(" ")[0];
        }
      }
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts,
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);